function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "closed_caption-24px"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1066",
  "data-name": "Path 1066",
  d: "M0,0H24V24H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_1475",
  "data-name": "Rectangle 1475",
  transform: "translate(3 4)",
  fill: "#fdd67c",
  stroke: "#00a0af",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 16,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 17,
  height: 15,
  rx: 1.5,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1069",
  "data-name": "Path 1069",
  d: "M10,14l2,3,2-3v4h2V11H14l-2,3-2-3H8v7h2Z",
  transform: "translate(0 -2)",
  fill: "#00a0af"
});

var SvgIconMasterInstrument = function SvgIconMasterInstrument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Master_Instrument",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMasterInstrument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon-Master_Instrument.2f423544.svg";
export { ForwardRef as ReactComponent };